import { Alert, Snackbar } from "@mui/material";

const SnackbarModal = ({
  open = false,
  onClose = null,
  severity = "error",
  message = null,
}) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={10000}
      sx={{
        // Above site nav (.nav-responsive uses z-index: 99999)
        zIndex: 100000,
        // Keep clear of sticky header on phone/tablet; center float on large screens
        top: {
          xs: "88px !important",
          sm: "100px !important",
          md: "108px !important",
          lg: "24px !important",
        },
        left: {
          xs: "8px !important",
          sm: "12px !important",
          md: "16px !important",
          lg: "50% !important",
        },
        right: {
          xs: "8px !important",
          sm: "12px !important",
          md: "16px !important",
          lg: "auto !important",
        },
        transform: {
          xs: "none !important",
          sm: "none !important",
          md: "none !important",
          lg: "translateX(-50%) !important",
        },
        width: {
          xs: "calc(100% - 16px)",
          sm: "calc(100% - 24px)",
          md: "calc(100% - 32px)",
          lg: "auto",
        },
        maxWidth: {
          xs: "100%",
          sm: "100%",
          md: "100%",
          lg: 560,
        },
        boxSizing: "border-box",
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          width: "100%",
          alignItems: "flex-start",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
          "& .MuiAlert-message": {
            paddingTop: "2px",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
            whiteSpace: "normal",
            lineHeight: 1.5,
            fontSize: {
              xs: "0.8rem",
              sm: "0.85rem",
              md: "0.875rem",
            },
            fontFamily: "Tajawal, sans-serif",
          },
          "& .MuiAlert-icon": {
            marginTop: "2px",
            paddingTop: "4px",
          },
          "& .MuiAlert-action": {
            paddingTop: 0,
            marginRight: 0,
            alignItems: "flex-start",
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarModal;
